import React from 'react';
import { LeadRow } from './LeadRow';

/**
 * Leads table component for desktop view displaying leads in a tabular format.
 */
export const LeadsTable = ({
    leads,
    executionMap = new Map(),
    openLeadDrawer,
    openMenu,
    toggleMenu,
    onArchiveLead,
    onUnarchiveLead,
    onDeleteLead,
}) => {
    return (
        <table className="w-full text-left border-collapse">
            <thead className="sticky top-0 bg-white z-10 border-b border-notion-border">
                <tr>
                    <th className="py-3 px-4 text-[11px] font-semibold text-stone-400 uppercase tracking-wider w-1/3">Lead</th>
                    <th className="py-3 px-4 text-[11px] font-semibold text-stone-400 uppercase tracking-wider w-40">
                        Automation
                    </th>
                    <th className="py-3 px-4 text-[11px] font-semibold text-stone-400 uppercase tracking-wider w-1/5">
                        Interest
                    </th>
                    <th className="py-3 px-4 text-[11px] font-semibold text-stone-400 uppercase tracking-wider">Tags</th>
                    <th className="py-3 px-4 text-[11px] font-semibold text-stone-400 uppercase tracking-wider text-right">
                        Last Contact
                    </th>
                    <th className="py-3 px-4 w-20"></th>
                </tr>
            </thead>
            <tbody className="text-sm divide-y divide-notion-border">
                {leads.map((lead) => (
                    <LeadRow
                        key={lead.id}
                        lead={lead}
                        executions={executionMap.get(lead.id) || []}
                        openLeadDrawer={openLeadDrawer}
                        openMenu={openMenu}
                        toggleMenu={toggleMenu}
                        onArchiveLead={onArchiveLead}
                        onUnarchiveLead={onUnarchiveLead}
                        onDeleteLead={onDeleteLead}
                    />
                ))}
            </tbody>
        </table>
    );
};

export default LeadsTable;
